<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="block relative w-full mt-2">
      <div class="body_inner">
        <div class="block top-block mb-4">
          <h2
            class="
              block
              text-darkgreen text-sm
              font-bold
              m-0
              title-block
              text-center
            "
          >
            {{ $t("pages.application_waiting.title") }}
          </h2>
          <p
            class="
              block
              text-lightGrey text-sm
              font-bold
              mt-0
              mb-0
              title-block
              text-center
            "
          >
            {{ $t("pages.application_waiting.subtitle") }}
          </p>
        </div>

        <div class="block relative mb-2 form-group">
          <label class="block relative text-base mb-2 font-bold">
            {{ $t("pages.application_waiting.Your_applications_since") }}
          </label>
          <div class="ds-cunstome-picker">
            <div class="flex items-center justify-start">
              <div class="w-10/12">
                <div
                  class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    rounded
                    h-11
                    relative
                    datepicker-main
                    date-inputgroup
                  "
                >
                  <span
                    class="
                      input-group-addon
                      flex
                      items-center
                      justify-center
                      h-full
                      absolute
                      left-0
                      top-0
                      pl-2
                      pr-2
                      z-10
                    "
                  >
                    <img
                      src="./../../assets/images/calender.png"
                      alt="Date Picker Image"
                    />
                  </span>
                  <datepicker
                    v-model="date"
                    input-class="block border-none outline-none box-shadow-none w-full    text-sm bg-transparent pl-11 h-11"
                    :placeholder="$t('pages.landing.input.placeholder')"
                    :language="lang"
                    format="dd.MM.yyyy"
                    :highlighted="highlighted"
                    :disabled-dates="{ to: yesterday }"
                    @input="changedDate"
                    @selected="selectedDate"
                  />
                </div>
              </div>
              <div class="w-2/12 pl-4 pr-0">
                <button
                  class="
                    relative
                    flex
                    items-center
                    justify-center
                    flex-nowrap
                    text-darkblack text-sm
                    walter-footer
                    p-1.5
                    border
                    solid
                    border-darkgreen
                    rounded
                    w-full
                    text-center
                    bg-darkgreen
                    h-11
                  "
                  @click="displayfilter"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.25 0C0.568203 0 0 0.568203 0 1.25V2.79492C0 3.94325 0.527739 5.02942 1.42969 5.74023L6.5 9.73535V17.25C6.50007 17.3877 6.53806 17.5228 6.60981 17.6404C6.68155 17.7579 6.78429 17.8535 6.90674 17.9165C7.0292 17.9796 7.16665 18.0077 7.30403 17.9978C7.44141 17.9879 7.5734 17.9403 7.68555 17.8604L11.1855 15.3604C11.2828 15.291 11.362 15.1994 11.4167 15.0933C11.4714 14.9871 11.5 14.8694 11.5 14.75V9.73438L16.5703 5.74023C17.4723 5.02942 18 3.94325 18 2.79492V1.25C18 0.568203 17.4318 0 16.75 0H1.25ZM1.5 1.5H16.5V2.79492C16.5 3.4846 16.1846 4.13434 15.6426 4.56152L10.6436 8.5H7.35645L2.35742 4.56152C1.81537 4.13434 1.5 3.4846 1.5 2.79492V1.5ZM8 10H10V14.3643L8 15.793V10Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group block relative mt-2 mb-4">
          <lable
            class="
              block
              relative
              flex
              items-center
              justify-start
              text-sm
              font-medium
            "
          >
            Sortieren nach
            <span class="flex ml-1.5">
              <svg
                class="w-3 h-3"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4957 0.992327C14.3637 0.995445 14.2382 1.05068 14.1467 1.14597L8.00025 7.29246L1.85377 1.14597C1.80716 1.09798 1.7514 1.05982 1.68978 1.03377C1.62817 1.00771 1.56195 0.994283 1.49505 0.99428C1.39554 0.994304 1.2983 1.02402 1.21577 1.07961C1.13325 1.13521 1.06919 1.21417 1.03178 1.30638C0.994383 1.39859 0.985343 1.49986 1.00582 1.59724C1.0263 1.69462 1.07536 1.78367 1.14674 1.853L7.64674 8.353C7.74051 8.44674 7.86767 8.49939 8.00025 8.49939C8.13284 8.49939 8.26 8.44674 8.35377 8.353L14.8538 1.853C14.9265 1.78322 14.9764 1.69309 14.997 1.59444C15.0176 1.49578 15.0079 1.39321 14.9692 1.30016C14.9305 1.20711 14.8646 1.12793 14.7801 1.073C14.6956 1.01807 14.5964 0.989947 14.4957 0.992327Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
          </lable>
        </div>

        <div class="list-items block relative">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
          >
            <div class="flex top-block mb-6 pt-4 pb-4 pl-3 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  Wysochki/Walter
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mt-2
                    mb-0
                    text-xs
                    font-normal
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  München
                </p>
              </div>
              <div class="right-block w-2/4 relative">
                <span
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                  "
                >
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    mt-2
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  1.680 Euro
                </p>
              </div>
            </div>

            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-4
                pb-4
                pl-4
                pr-4
                bg-lightgray
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.0566 5.5L0.5 9.59788L0.5 1.40212L7.0566 5.5Z"
                    stroke="#63B15B"
                  />
                  <path d="M9.5 1H11.5V10H9.5L9.5 1Z" stroke="#63B15B" />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">21.02.21</span>
              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.16667 0C0.976021 0 0 0.976021 0 2.16667V9.83333C0 11.024 0.976021 12 2.16667 12H9.83333C11.024 12 12 11.024 12 9.83333V2.16667C12 0.976021 11.024 0 9.83333 0H2.16667ZM2.16667 1H9.83333C10.4834 1 11 1.51665 11 2.16667V2.66667H1V2.16667C1 1.51665 1.51665 1 2.16667 1ZM1 3.66667H11V9.83333C11 10.4834 10.4834 11 9.83333 11H2.16667C1.51665 11 1 10.4834 1 9.83333V3.66667ZM8.51367 4.99479C8.44089 4.99345 8.36868 5.00803 8.30211 5.03749C8.23554 5.06695 8.17621 5.11059 8.12826 5.16536L5.48047 8.10677L4.18685 6.81315C4.14078 6.76517 4.08559 6.72686 4.02453 6.70046C3.96346 6.67407 3.89775 6.66013 3.83123 6.65945C3.76471 6.65878 3.69872 6.67138 3.63713 6.69653C3.57555 6.72167 3.51959 6.75885 3.47256 6.80589C3.42552 6.85293 3.38834 6.90888 3.36319 6.97047C3.33805 7.03206 3.32544 7.09804 3.32612 7.16456C3.3268 7.23108 3.34074 7.2968 3.36713 7.35786C3.39352 7.41893 3.43183 7.47411 3.47982 7.52018L5.14648 9.18685C5.19447 9.23486 5.25173 9.2726 5.31477 9.29776C5.37781 9.32293 5.44532 9.33499 5.51317 9.33323C5.58103 9.33146 5.64781 9.3159 5.70946 9.28749C5.7711 9.25907 5.82632 9.21841 5.87175 9.16797L8.87175 5.83464C8.93736 5.76382 8.98107 5.67553 8.99761 5.58042C9.01414 5.48531 9.0028 5.38745 8.96494 5.29865C8.92708 5.20985 8.86432 5.1339 8.78424 5.07998C8.70417 5.02606 8.61019 4.99648 8.51367 4.99479Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">
                {{ $t("pages.application_waiting.your_letter_of_application") }}
              </span>

              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 1C3.6875 1 1 3.6875 1 7C1 10.3125 3.6875 13 7 13C10.3125 13 13 10.3125 13 7C13 3.6875 10.3125 1 7 1Z"
                    stroke="#C6C6D1"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M7 3V7.5H10"
                    stroke="#C6C6D1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-lightGrey">
                Warten
              </span>
            </div>
          </div>

          <div class="flex align-center justify-start text-xs font-medium mb-7">
            <div class="left-block w-2/5 relative">
              <p
                class="
                  relative
                  text-xs text-left
                  flex
                  items-center
                  justify-start
                  font-medium
                "
              >
                <span class="icon mr-2">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 10 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.3676 0.746249C4.27021 0.749088 4.17775 0.789715 4.10979 0.859531L0.609791 4.35953C0.539492 4.42986 0.5 4.52523 0.5 4.62467C0.5 4.72411 0.539492 4.81948 0.609791 4.8898L4.10979 8.3898C4.14435 8.42579 4.18573 8.45453 4.23153 8.47432C4.27733 8.49411 4.32662 8.50457 4.37651 8.50508C4.4264 8.50558 4.47589 8.49613 4.52208 8.47727C4.56827 8.45842 4.61023 8.43053 4.64551 8.39525C4.68079 8.35997 4.70868 8.31801 4.72753 8.27182C4.74639 8.22563 4.75585 8.17614 4.75534 8.12625C4.75483 8.07636 4.74437 8.02707 4.72458 7.98127C4.70479 7.93547 4.67605 7.89409 4.64006 7.85953L1.7802 4.99967H9.12493C9.17462 5.00037 9.22396 4.99119 9.27007 4.97266C9.31618 4.95413 9.35815 4.92662 9.39354 4.89173C9.42893 4.85684 9.45703 4.81526 9.47621 4.76941C9.49539 4.72357 9.50527 4.67436 9.50527 4.62467C9.50527 4.57497 9.49539 4.52577 9.47621 4.47992C9.45703 4.43408 9.42893 4.3925 9.39354 4.35761C9.35815 4.32272 9.31618 4.29521 9.27007 4.27668C9.22396 4.25815 9.17462 4.24896 9.12493 4.24967H1.7802L4.64006 1.3898C4.69416 1.33712 4.7311 1.26932 4.74603 1.19529C4.76097 1.12127 4.7532 1.04446 4.72376 0.974916C4.69432 0.905374 4.64457 0.84634 4.58102 0.80554C4.51747 0.76474 4.44309 0.744075 4.3676 0.746249Z"
                      fill="#676666"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.family_profile") }}
              </p>
            </div>
            <div class="right-block w-3/5 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-xs text-right
                  flex
                  items-center
                  justify-end
                  text-danger
                  font-medium
                "
              >
                <span class="icon mr-0.5">
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 0C3.41594 0 0.5 2.91594 0.5 6.5C0.5 10.0841 3.41594 13 7 13C10.5841 13 13.5 10.0841 13.5 6.5C13.5 2.91594 10.5841 0 7 0ZM9.35344 8.14656C9.40182 8.19253 9.44051 8.24772 9.46723 8.30888C9.49395 8.37003 9.50816 8.43592 9.50901 8.50265C9.50986 8.56938 9.49735 8.63561 9.47221 8.69743C9.44706 8.75925 9.4098 8.81541 9.36261 8.86261C9.31541 8.9098 9.25925 8.94706 9.19743 8.97221C9.13561 8.99735 9.06938 9.00986 9.00265 9.00901C8.93592 9.00816 8.87003 8.99395 8.80888 8.96723C8.74772 8.94051 8.69253 8.90182 8.64656 8.85344L7 7.20719L5.35344 8.85344C5.25891 8.94325 5.13303 8.99258 5.00265 8.99091C4.87227 8.98924 4.7477 8.9367 4.6555 8.8445C4.5633 8.7523 4.51076 8.62773 4.50909 8.49735C4.50742 8.36697 4.55675 8.24109 4.64656 8.14656L6.29281 6.5L4.64656 4.85344C4.55675 4.75891 4.50742 4.63303 4.50909 4.50265C4.51076 4.37227 4.5633 4.2477 4.6555 4.1555C4.7477 4.0633 4.87227 4.01076 5.00265 4.00909C5.13303 4.00742 5.25891 4.05675 5.35344 4.14656L7 5.79281L8.64656 4.14656C8.74109 4.05675 8.86697 4.00742 8.99735 4.00909C9.12773 4.01076 9.2523 4.0633 9.3445 4.1555C9.4367 4.2477 9.48924 4.37227 9.49091 4.50265C9.49258 4.63303 9.44325 4.75891 9.35344 4.85344L7.70719 6.5L9.35344 8.14656Z"
                      fill="#EE5B64"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.withdraw_application") }}
              </p>
            </div>
          </div>
        </div>
        <div class="list-items block relative">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
          >
            <div class="flex top-block mb-6 pt-4 pb-4 pl-3 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  Weser/Müller
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mt-2
                    mb-0
                    text-xs
                    font-normal
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  München
                </p>
              </div>

              <div class="right-block w-2/4 relative">
                <span
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                  "
                >
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    mt-2
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  1.680 Euro
                </p>
              </div>
            </div>

            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-4
                pb-4
                pl-4
                pr-4
                bg-lightgray
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.0566 5.5L0.5 9.59788L0.5 1.40212L7.0566 5.5Z"
                    stroke="#63B15B"
                  />
                  <path d="M9.5 1H11.5V10H9.5L9.5 1Z" stroke="#63B15B" />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">21.02.21</span>
              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.16667 0C0.976021 0 0 0.976021 0 2.16667V9.83333C0 11.024 0.976021 12 2.16667 12H9.83333C11.024 12 12 11.024 12 9.83333V2.16667C12 0.976021 11.024 0 9.83333 0H2.16667ZM2.16667 1H9.83333C10.4834 1 11 1.51665 11 2.16667V2.66667H1V2.16667C1 1.51665 1.51665 1 2.16667 1ZM1 3.66667H11V9.83333C11 10.4834 10.4834 11 9.83333 11H2.16667C1.51665 11 1 10.4834 1 9.83333V3.66667ZM8.51367 4.99479C8.44089 4.99345 8.36868 5.00803 8.30211 5.03749C8.23554 5.06695 8.17621 5.11059 8.12826 5.16536L5.48047 8.10677L4.18685 6.81315C4.14078 6.76517 4.08559 6.72686 4.02453 6.70046C3.96346 6.67407 3.89775 6.66013 3.83123 6.65945C3.76471 6.65878 3.69872 6.67138 3.63713 6.69653C3.57555 6.72167 3.51959 6.75885 3.47256 6.80589C3.42552 6.85293 3.38834 6.90888 3.36319 6.97047C3.33805 7.03206 3.32544 7.09804 3.32612 7.16456C3.3268 7.23108 3.34074 7.2968 3.36713 7.35786C3.39352 7.41893 3.43183 7.47411 3.47982 7.52018L5.14648 9.18685C5.19447 9.23486 5.25173 9.2726 5.31477 9.29776C5.37781 9.32293 5.44532 9.33499 5.51317 9.33323C5.58103 9.33146 5.64781 9.3159 5.70946 9.28749C5.7711 9.25907 5.82632 9.21841 5.87175 9.16797L8.87175 5.83464C8.93736 5.76382 8.98107 5.67553 8.99761 5.58042C9.01414 5.48531 9.0028 5.38745 8.96494 5.29865C8.92708 5.20985 8.86432 5.1339 8.78424 5.07998C8.70417 5.02606 8.61019 4.99648 8.51367 4.99479Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">Ihre Bewerbung</span>

              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 1C3.6875 1 1 3.6875 1 7C1 10.3125 3.6875 13 7 13C10.3125 13 13 10.3125 13 7C13 3.6875 10.3125 1 7 1Z"
                    stroke="#C6C6D1"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M7 3V7.5H10"
                    stroke="#C6C6D1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-lightGrey">
                Warten
              </span>
            </div>
          </div>

          <div class="flex align-center justify-start text-xs font-medium mb-7">
            <div class="left-block w-2/5 relative">
              <p
                class="
                  relative
                  text-xs text-left
                  flex
                  items-center
                  justify-start
                  font-medium
                "
              >
                <span class="icon mr-2">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 10 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.3676 0.746249C4.27021 0.749088 4.17775 0.789715 4.10979 0.859531L0.609791 4.35953C0.539492 4.42986 0.5 4.52523 0.5 4.62467C0.5 4.72411 0.539492 4.81948 0.609791 4.8898L4.10979 8.3898C4.14435 8.42579 4.18573 8.45453 4.23153 8.47432C4.27733 8.49411 4.32662 8.50457 4.37651 8.50508C4.4264 8.50558 4.47589 8.49613 4.52208 8.47727C4.56827 8.45842 4.61023 8.43053 4.64551 8.39525C4.68079 8.35997 4.70868 8.31801 4.72753 8.27182C4.74639 8.22563 4.75585 8.17614 4.75534 8.12625C4.75483 8.07636 4.74437 8.02707 4.72458 7.98127C4.70479 7.93547 4.67605 7.89409 4.64006 7.85953L1.7802 4.99967H9.12493C9.17462 5.00037 9.22396 4.99119 9.27007 4.97266C9.31618 4.95413 9.35815 4.92662 9.39354 4.89173C9.42893 4.85684 9.45703 4.81526 9.47621 4.76941C9.49539 4.72357 9.50527 4.67436 9.50527 4.62467C9.50527 4.57497 9.49539 4.52577 9.47621 4.47992C9.45703 4.43408 9.42893 4.3925 9.39354 4.35761C9.35815 4.32272 9.31618 4.29521 9.27007 4.27668C9.22396 4.25815 9.17462 4.24896 9.12493 4.24967H1.7802L4.64006 1.3898C4.69416 1.33712 4.7311 1.26932 4.74603 1.19529C4.76097 1.12127 4.7532 1.04446 4.72376 0.974916C4.69432 0.905374 4.64457 0.84634 4.58102 0.80554C4.51747 0.76474 4.44309 0.744075 4.3676 0.746249Z"
                      fill="#676666"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.family_profile") }}
              </p>
            </div>
            <div class="right-block w-3/5 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-xs text-right
                  flex
                  items-center
                  justify-end
                  text-danger
                  font-medium
                "
              >
                <span class="icon mr-0.5">
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 0C3.41594 0 0.5 2.91594 0.5 6.5C0.5 10.0841 3.41594 13 7 13C10.5841 13 13.5 10.0841 13.5 6.5C13.5 2.91594 10.5841 0 7 0ZM9.35344 8.14656C9.40182 8.19253 9.44051 8.24772 9.46723 8.30888C9.49395 8.37003 9.50816 8.43592 9.50901 8.50265C9.50986 8.56938 9.49735 8.63561 9.47221 8.69743C9.44706 8.75925 9.4098 8.81541 9.36261 8.86261C9.31541 8.9098 9.25925 8.94706 9.19743 8.97221C9.13561 8.99735 9.06938 9.00986 9.00265 9.00901C8.93592 9.00816 8.87003 8.99395 8.80888 8.96723C8.74772 8.94051 8.69253 8.90182 8.64656 8.85344L7 7.20719L5.35344 8.85344C5.25891 8.94325 5.13303 8.99258 5.00265 8.99091C4.87227 8.98924 4.7477 8.9367 4.6555 8.8445C4.5633 8.7523 4.51076 8.62773 4.50909 8.49735C4.50742 8.36697 4.55675 8.24109 4.64656 8.14656L6.29281 6.5L4.64656 4.85344C4.55675 4.75891 4.50742 4.63303 4.50909 4.50265C4.51076 4.37227 4.5633 4.2477 4.6555 4.1555C4.7477 4.0633 4.87227 4.01076 5.00265 4.00909C5.13303 4.00742 5.25891 4.05675 5.35344 4.14656L7 5.79281L8.64656 4.14656C8.74109 4.05675 8.86697 4.00742 8.99735 4.00909C9.12773 4.01076 9.2523 4.0633 9.3445 4.1555C9.4367 4.2477 9.48924 4.37227 9.49091 4.50265C9.49258 4.63303 9.44325 4.75891 9.35344 4.85344L7.70719 6.5L9.35344 8.14656Z"
                      fill="#EE5B64"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.withdraw_application") }}
              </p>
            </div>
          </div>
        </div>
        <div class="list-items block relative">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
          >
            <div class="flex top-block mb-6 pt-4 pb-4 pl-3 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  Ruth/Schulten
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mt-2
                    mb-0
                    text-xs
                    font-normal
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  München
                </p>
              </div>

              <div class="right-block w-2/4 relative">
                <span
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                  "
                >
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    mt-2
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  1.680 Euro
                </p>
              </div>
            </div>

            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-4
                pb-4
                pl-4
                pr-4
                bg-lightgray
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.0566 5.5L0.5 9.59788L0.5 1.40212L7.0566 5.5Z"
                    stroke="#63B15B"
                  />
                  <path d="M9.5 1H11.5V10H9.5L9.5 1Z" stroke="#63B15B" />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">21.02.21</span>
              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.16667 0C0.976021 0 0 0.976021 0 2.16667V9.83333C0 11.024 0.976021 12 2.16667 12H9.83333C11.024 12 12 11.024 12 9.83333V2.16667C12 0.976021 11.024 0 9.83333 0H2.16667ZM2.16667 1H9.83333C10.4834 1 11 1.51665 11 2.16667V2.66667H1V2.16667C1 1.51665 1.51665 1 2.16667 1ZM1 3.66667H11V9.83333C11 10.4834 10.4834 11 9.83333 11H2.16667C1.51665 11 1 10.4834 1 9.83333V3.66667ZM8.51367 4.99479C8.44089 4.99345 8.36868 5.00803 8.30211 5.03749C8.23554 5.06695 8.17621 5.11059 8.12826 5.16536L5.48047 8.10677L4.18685 6.81315C4.14078 6.76517 4.08559 6.72686 4.02453 6.70046C3.96346 6.67407 3.89775 6.66013 3.83123 6.65945C3.76471 6.65878 3.69872 6.67138 3.63713 6.69653C3.57555 6.72167 3.51959 6.75885 3.47256 6.80589C3.42552 6.85293 3.38834 6.90888 3.36319 6.97047C3.33805 7.03206 3.32544 7.09804 3.32612 7.16456C3.3268 7.23108 3.34074 7.2968 3.36713 7.35786C3.39352 7.41893 3.43183 7.47411 3.47982 7.52018L5.14648 9.18685C5.19447 9.23486 5.25173 9.2726 5.31477 9.29776C5.37781 9.32293 5.44532 9.33499 5.51317 9.33323C5.58103 9.33146 5.64781 9.3159 5.70946 9.28749C5.7711 9.25907 5.82632 9.21841 5.87175 9.16797L8.87175 5.83464C8.93736 5.76382 8.98107 5.67553 8.99761 5.58042C9.01414 5.48531 9.0028 5.38745 8.96494 5.29865C8.92708 5.20985 8.86432 5.1339 8.78424 5.07998C8.70417 5.02606 8.61019 4.99648 8.51367 4.99479Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1">
                {{ $t("pages.application_waiting.your_letter_of_application") }}
              </span>
              <span class="icon mr-1">
                <svg
                  class="w-6 h-6"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
                    fill="#C6C6D1"
                  />
                </svg>
              </span>
              <span class="icon mr-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 1C3.6875 1 1 3.6875 1 7C1 10.3125 3.6875 13 7 13C10.3125 13 13 10.3125 13 7C13 3.6875 10.3125 1 7 1Z"
                    stroke="#C6C6D1"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M7 3V7.5H10"
                    stroke="#C6C6D1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-lightGrey">
                Warten
              </span>
            </div>
          </div>
          <div class="flex align-center justify-start text-xs font-medium mb-7">
            <div class="left-block w-2/5 relative">
              <p
                class="
                  relative
                  text-xs text-left
                  flex
                  items-center
                  justify-start
                  font-medium
                "
              >
                <span class="icon mr-2">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 10 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.3676 0.746249C4.27021 0.749088 4.17775 0.789715 4.10979 0.859531L0.609791 4.35953C0.539492 4.42986 0.5 4.52523 0.5 4.62467C0.5 4.72411 0.539492 4.81948 0.609791 4.8898L4.10979 8.3898C4.14435 8.42579 4.18573 8.45453 4.23153 8.47432C4.27733 8.49411 4.32662 8.50457 4.37651 8.50508C4.4264 8.50558 4.47589 8.49613 4.52208 8.47727C4.56827 8.45842 4.61023 8.43053 4.64551 8.39525C4.68079 8.35997 4.70868 8.31801 4.72753 8.27182C4.74639 8.22563 4.75585 8.17614 4.75534 8.12625C4.75483 8.07636 4.74437 8.02707 4.72458 7.98127C4.70479 7.93547 4.67605 7.89409 4.64006 7.85953L1.7802 4.99967H9.12493C9.17462 5.00037 9.22396 4.99119 9.27007 4.97266C9.31618 4.95413 9.35815 4.92662 9.39354 4.89173C9.42893 4.85684 9.45703 4.81526 9.47621 4.76941C9.49539 4.72357 9.50527 4.67436 9.50527 4.62467C9.50527 4.57497 9.49539 4.52577 9.47621 4.47992C9.45703 4.43408 9.42893 4.3925 9.39354 4.35761C9.35815 4.32272 9.31618 4.29521 9.27007 4.27668C9.22396 4.25815 9.17462 4.24896 9.12493 4.24967H1.7802L4.64006 1.3898C4.69416 1.33712 4.7311 1.26932 4.74603 1.19529C4.76097 1.12127 4.7532 1.04446 4.72376 0.974916C4.69432 0.905374 4.64457 0.84634 4.58102 0.80554C4.51747 0.76474 4.44309 0.744075 4.3676 0.746249Z"
                      fill="#676666"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.family_profile") }}
              </p>
            </div>
            <div class="right-block w-3/5 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-xs text-right
                  flex
                  items-center
                  justify-end
                  text-danger
                  font-medium
                "
              >
                <span class="icon mr-0.5">
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 0C3.41594 0 0.5 2.91594 0.5 6.5C0.5 10.0841 3.41594 13 7 13C10.5841 13 13.5 10.0841 13.5 6.5C13.5 2.91594 10.5841 0 7 0ZM9.35344 8.14656C9.40182 8.19253 9.44051 8.24772 9.46723 8.30888C9.49395 8.37003 9.50816 8.43592 9.50901 8.50265C9.50986 8.56938 9.49735 8.63561 9.47221 8.69743C9.44706 8.75925 9.4098 8.81541 9.36261 8.86261C9.31541 8.9098 9.25925 8.94706 9.19743 8.97221C9.13561 8.99735 9.06938 9.00986 9.00265 9.00901C8.93592 9.00816 8.87003 8.99395 8.80888 8.96723C8.74772 8.94051 8.69253 8.90182 8.64656 8.85344L7 7.20719L5.35344 8.85344C5.25891 8.94325 5.13303 8.99258 5.00265 8.99091C4.87227 8.98924 4.7477 8.9367 4.6555 8.8445C4.5633 8.7523 4.51076 8.62773 4.50909 8.49735C4.50742 8.36697 4.55675 8.24109 4.64656 8.14656L6.29281 6.5L4.64656 4.85344C4.55675 4.75891 4.50742 4.63303 4.50909 4.50265C4.51076 4.37227 4.5633 4.2477 4.6555 4.1555C4.7477 4.0633 4.87227 4.01076 5.00265 4.00909C5.13303 4.00742 5.25891 4.05675 5.35344 4.14656L7 5.79281L8.64656 4.14656C8.74109 4.05675 8.86697 4.00742 8.99735 4.00909C9.12773 4.01076 9.2523 4.0633 9.3445 4.1555C9.4367 4.2477 9.48924 4.37227 9.49091 4.50265C9.49258 4.63303 9.44325 4.75891 9.35344 4.85344L7.70719 6.5L9.35344 8.14656Z"
                      fill="#EE5B64"
                    />
                  </svg>
                </span>
                {{ $t("pages.application_waiting.withdraw_application") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showmodel"
      class="block fixed top-0 left-0 w-full h-full model-block"
    >
      <div class="flex items-end justify-start model-body w-full h-full">
        <div
          class="
            flex
            items-end
            justify-start
            model-body
            w-full
            h-full
            black-overlay
            absolute
            left-0
            top-0
          "
          @click="filterclose"
        ></div>
        <div class="block w-full bg-white rounded-t-xl relative">
          <div class="body_inners pl-4 pr-4">
            <div
              class="flex items-center justify-between top-block mb-8 pt-3 pb-3"
            >
              <span class="cross-cion" @click="filterclose">
                <svg
                  class="w-4 h-4"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7433 0.489467C16.5452 0.494145 16.357 0.576998 16.2198 0.719936L9.00012 7.93966L1.78039 0.719936C1.71048 0.647943 1.62684 0.59071 1.53441 0.551626C1.44198 0.512541 1.34265 0.492401 1.2423 0.492397C1.09304 0.492433 0.947187 0.537001 0.823398 0.620397C0.699609 0.703794 0.603515 0.822226 0.547413 0.960543C0.49131 1.09886 0.47775 1.25077 0.508468 1.39683C0.539185 1.5429 0.612782 1.67648 0.719843 1.78048L7.93957 9.00021L0.719843 16.2199C0.647865 16.289 0.590399 16.3718 0.550812 16.4634C0.511224 16.555 0.490311 16.6536 0.489297 16.7534C0.488282 16.8531 0.507187 16.9521 0.544904 17.0445C0.58262 17.1369 0.638391 17.2208 0.70895 17.2914C0.779508 17.3619 0.863436 17.4177 0.955818 17.4554C1.0482 17.4931 1.14718 17.512 1.24696 17.511C1.34674 17.51 1.44531 17.4891 1.53691 17.4495C1.6285 17.4099 1.71128 17.3525 1.78039 17.2805L9.00012 10.0608L16.2198 17.2805C16.2889 17.3525 16.3717 17.4099 16.4633 17.4495C16.5549 17.4891 16.6535 17.51 16.7533 17.511C16.8531 17.512 16.952 17.4931 17.0444 17.4554C17.1368 17.4177 17.2207 17.3619 17.2913 17.2914C17.3618 17.2208 17.4176 17.1369 17.4553 17.0445C17.493 16.9521 17.5119 16.8531 17.5109 16.7534C17.5099 16.6536 17.489 16.555 17.4494 16.4634C17.4098 16.3718 17.3524 16.289 17.2804 16.2199L10.0607 9.00021L17.2804 1.78048C17.3895 1.6758 17.4643 1.54061 17.4952 1.39263C17.5261 1.24465 17.5116 1.09079 17.4535 0.951215C17.3955 0.811641 17.2966 0.69287 17.1698 0.610472C17.0431 0.528075 16.8944 0.485897 16.7433 0.489467Z"
                    fill="#676666"
                  />
                </svg>
              </span>
              <label class="block capitalize text-sm text-darkblack font-bold">
                Filters
              </label>
              <label
                class="
                  flex
                  items-center
                  justify-end
                  text-sm
                  font-medium
                  text-right text-darkgreen
                "
              >
                Abwerfen
              
              </label>
            </div>

            <div class="block relative mb-6">
              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input type="checkbox" checked />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  Alle anzeigen
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  Aktive Bewerbungen
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  Abgelehnte Bewerbungen
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  In Bearbeitung
                </label>
              </div>

              <div
                class="
                  item
                  relative
                  flex
                  items-center
                  justify-start
                  mb-6
                  border
                  solid
                  border-agray1
                "
              ></div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  Favoriten
                </label>
              </div>
            </div>

            <div class="form-group mb-6 w-full">
              <button
                class="
                  w-full
                  flex
                  items-center
                  justify-center
                  btn_apply
                  rounded-lg
                  text-white
                  btn_action
                  font-semibold
                  text-sm
                "
              >
                <span class="flex mr-2.5">
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.75 0C1.0682 0 0.5 0.568203 0.5 1.25V2.79492C0.5 3.94325 1.02774 5.02942 1.92969 5.74023L7 9.73535V17.25C7.00007 17.3877 7.03806 17.5228 7.10981 17.6404C7.18155 17.7579 7.28429 17.8535 7.40674 17.9165C7.5292 17.9796 7.66665 18.0077 7.80403 17.9978C7.94141 17.9879 8.0734 17.9403 8.18555 17.8604L11.6855 15.3604C11.7828 15.291 11.862 15.1994 11.9167 15.0933C11.9714 14.9871 12 14.8694 12 14.75V9.73438L17.0703 5.74023C17.9723 5.02942 18.5 3.94325 18.5 2.79492V1.25C18.5 0.568203 17.9318 0 17.25 0H1.75ZM2 1.5H17V2.79492C17 3.4846 16.6846 4.13434 16.1426 4.56152L11.1436 8.5H7.85645L2.85742 4.56152C2.31537 4.13434 2 3.4846 2 2.79492V1.5ZM8.5 10H10.5V14.3643L8.5 15.793V10Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Zeige 15 Resultate
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { de, pl, en } from "vuejs-datepicker/dist/locale";

export default {
  name: "ApplicationWaiting",
  components: { Datepicker },
  data() {
    return {
      showmodel: false,
      date: null,
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
    };
  },
  computed: {
    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }
      return en;
    },
    yesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
  },
  methods: {
    changedDate() {
      this.$store.commit(
        "mission/SET_ANONYMIZED_AVAILABILITY_DATE",
        this.date.toISOString().slice(0, 10)
      );
      this.$emit("date", this.date.toISOString().slice(0, 10));
    },

    selectedDate(date) {
      try {
        const today = new Date().toISOString().slice(0, 10);
        if (date.toISOString().slice(0, 10) < today) {
          this.error = this.$t("component.searchCard.beforeError");
          this.$emit("input", false);
        } else {
          this.error = "";
          this.$emit("input", true);
        }
      } catch {
        this.$emit("input", true);
      }
    },
    displayfilter() {
      this.showmodel = true;
    },
    filterclose() {
      this.showmodel = false;
    },
  },
};
</script>

<style scoped>
.ds-cunstome-picker .input-group-addon {
  left: 0px !important;
}
.search-card__datepicker-input {
  padding-left: 45px;
}
.ds-cunstome-picker .vdp-datepicker {
  width: 100%;
  height: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  vertical-align: middle;
}
.ds-cunstome-picker .vdp-datepicker input {
  padding-left: 40px;
}
.ds-cunstome-picker .vdp-datepicker div {
  height: 100%;
}
.custome_check {
  height: 20px;
  width: 20px;
  margin-right: 16px;
}
.custome_check .checkmark {
  width: 100%;
  height: 100%;
}
</style>
